import { render, staticRenderFns } from "./InvoicesReport.vue?vue&type=template&id=652f927f"
import script from "./InvoicesReport.vue?vue&type=script&lang=js"
export * from "./InvoicesReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports